export function footerPadding() {
    const elements = document.querySelectorAll('.site-colour-block.alignfull');
    if (elements.length > 0) {
        const lastElement = elements[elements.length - 1];
    
        lastElement.classList.add('site-colour-block__last-element'); // example of applying a style
    }

}